import React, { Fragment, useEffect, useState } from 'react';
import { OKRDrawer } from '../../Common/OKRDrawer';
import { Avatar, Box, Tooltip, Typography } from '@material-ui/core';
import { ReviewSettingsDrawer } from './ReviewSettingsDrawer';
import { getMonthDateYear, getMonthDateYearTime, getUserName } from '../../../config/utils';
import { CalendarIcon } from '../../../config/svg/CommonSvgIcon';
import { useDispatch } from 'react-redux';
import { fetchConversationGoalCompleted } from '../../../action/perform';

export const ReviewConversationsSettings: React.FC<any> = (props) => {
	const { t, categorySettingsOpen, handleSettingsDrawerClose, selectTab, teamReviewUserListResponse } = props;
	const [tabSelected, setTabSelected] = useState<Number>(0);
	const [loader, setLoader] = useState<boolean>(false);
	const handleTabChange = (event: any, newValue: Number) => {
		setTabSelected(newValue);
	};
	const dispatch = useDispatch();

	useEffect(() => {
		if (selectTab === 'conversation') {
			dispatch(
				fetchConversationGoalCompleted({
					entity: {
						commentDetailResponses: [],
					},
					pagingInfo: {},
				})
			);
			setTabSelected(0);
		} else if (selectTab === 'responseLog') {
			setTabSelected(1);
		}
	}, [selectTab]);
	return (
		<Fragment>
			<OKRDrawer
				open={categorySettingsOpen.open}
				drawerClassName='main-drawer-panel main-drawer-no-footer review-conversation-drawer'
				transitionDuration={{ enter: 500, exit: 1000 }}
				headerTitle={<>{t('teamReviewForText')}</>}
				children={
					<Box className='drawer-inner-content'>
						<ReviewSettingsDrawer
							kr={{
								...categorySettingsOpen.data,
								performanceGoalReviewCycleEmployeeId: categorySettingsOpen.data.performanceGoalReviewCycleEmployeeId,
								usersDetails: categorySettingsOpen.data,
								teamReviewUserListResponse: teamReviewUserListResponse,
							}}
							t={t}
							handleTabChange={handleTabChange}
							tabSelected={tabSelected}
							{...props}
							loader={loader}
							setLoader={setLoader}
						/>
					</Box>
				}
				moreButton={<></>}
				handleDrawerClose={(event) => handleSettingsDrawerClose(event)}
				handleSaveClick={(event) => handleSettingsDrawerClose(event)}
				handleCancelClick={(event) => handleSettingsDrawerClose(event)}
				hideDefaultButton={false}
				loader={loader}
				isFooterVisible={false}
				isSaveButtonDisabled={false}
				isAnyDrawerOpened={props.isAnyDrawerOpened}
				appDrawerInfo={props.appDrawerInfo}
			/>
		</Fragment>
	);
};
